import { SET_VEHICLE } from '../actions/types';

export default function vehicle(state = null, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_VEHICLE:
				return action.payload;

			// no default
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/vehicle.js